import { endOfYear, endOfMonth, startOfDay } from 'date-fns';

export const DATE_TYPE = {
  year: endOfYear(new Date()),
  month: endOfMonth(new Date()),
  day: startOfDay(new Date()),
};
